import { generalFacts, leadEvaluatedFacts, leadFacts, matchFacts } from './facts';
import { FactInfo, RuleInfo } from './types';

export const pricingRules: RuleInfo[] = [
  {
    type: 'pricingRule',
    params: {
      operations: {
        optional: false,
        type: 'list',
        typeInfo: {
          type: 'object',
          properties: {
            operation: {
              optional: false,
              type: 'enumerated',
              values: ['add', 'subtract', 'multiply', 'divide', 'set'],
              description: 'Operation to apply to the value'
            },
            operand: {
              optional: false,
              type: 'number',
              description: 'Value to apply to the operation'
            }
          }
        },
        description: 'Ordered list of operations to apply to the pricing rule'
      },
      score: {
        optional: false,
        type: 'number',
        description: 'The base score this match will receive before any modifiers are applied.'
      }
    }
  }
];

/**
 * Pricing rules can reference lead facts, general facts, lead evaluated facts, and match facts.
 */
export const pricingRulesFacts: FactInfo[] = [
  ...leadFacts,
  ...generalFacts,
  ...leadEvaluatedFacts,
  ...matchFacts
];
